// Sections of the account area, in header menu order. `href` mirrors
// UserPageLink: the settings section lives at /user, the rest at /user/<key>.
const ACCOUNT_SECTIONS = [
  { key: 'creations', label: 'My Creations', href: '/user/creations' },
  { key: 'orders', label: 'Orders', href: '/user/orders' },
  { key: 'credit', label: 'Parabo Credit', href: '/user/credit' },
  { key: 'cards', label: 'Saved Cards', href: '/user/cards' },
  { key: 'settings', label: 'Personal Info', href: '/user' },
];

export default ACCOUNT_SECTIONS;
